// Funkcja pomocnicza do usuwania pozycji z sitemap
function removeSitemapItem(sitemapBuilder: SitemapBuilder, name: string): SitemapBuilder
{
    const currentNodes = (sitemapBuilder as any).sitemap;

    if (currentNodes && Array.isArray(currentNodes))
    {
        const index = currentNodes.findIndex((p: any) => p.name === name);

        if (index !== -1)
        {
            currentNodes.splice(index, 1);
        }
    }

    return sitemapBuilder;
}

export default (sitemap: SitemapBuilder) =>
{
    removeSitemapItem(sitemap.find('[[[Moduły]]]'), '[[[CMS]]]');
    removeSitemapItem(sitemap.find('[[[Moduły]]]', '[[[Artykuły]]]'), '[[[Czołówka]]]');
    removeSitemapItem(sitemap.find('[[[Marketing]]]'), '[[[Slajdery]]]');
    removeSitemapItem(sitemap, '[[[Premium]]]');
    removeSitemapItem(sitemap.find('[[[Moduły]]]'), '[[[Aktualności]]]');
    removeSitemapItem(sitemap.find('[[[Moduły]]]'), '[[[Gazetka]]]');
    removeSitemapItem(sitemap.find('[[[System]]]'), '[[[Asystent AI]]]');
    removeSitemapItem(sitemap.find('[[[System]]]', '[[[Administracja]]]'), '[[[Zastępstwa]]]');

    sitemap.find('[[[System]]]', '[[[Monitoring]]]').after('[[[Monitor kolejek]]]', [
        {
            name: '[[[Pamięć podręczna]]]',
            route: 'combined-cache',
            namespace: 'Ideo.Core.Combined.Application.Permissions.Cache',
            auth: { all: ['CachePermissions@Manage'], any: [] }
        }
    ]);

    sitemap.find('[[[Marketing]]]')?.after('[[[Komentarze]]]', [
        {
            name: '[[[Polubienia]]]',
            icon: 'fa-regular fa-heart',
            children: [
                {
                    name: '[[[Ustawienia polubień]]]',
                    route: 'cms-marketing-likes',
                    auth: { all: ['LikesPermissions@View'], any: [] },
                    visible: true
                }
            ]
        }
    ]);

    sitemap.find('[[[System]]]', '[[[Administracja]]]').after('[[[Organizacja]]]', [
        {
            name: '[[[Stanowiska]]]',
            route: 'core-positions',
            namespace: 'Ideo.Core.Edito.Application.Permissions.Modules',
            auth: { all: ['JobPositionsPermissions@View'], any: [] },
            children: [
                {
                    name: '[[[Dodanie stanowiska]]]',
                    route: 'core-positions-add',
                    auth: { all: ['JobPositionsPermissions@Edit'], any: [] },
                    visible: false
                },
                {
                    name: '[[[Edycja stanowiska]]]',
                    route: 'core-positions-edit',
                    auth: { all: ['JobPositionsPermissions@Edit'], any: [] },
                    visible: false
                }
            ]
        }
    ]);

    sitemap.find('[[[Moduły]]]', '[[[Katalog linków]]]').after('[[[Lista linków]]]', [
        {
            name: '[[[Sortowanie linków]]]',
            route: 'intranet-link-links-sort',
            auth: { all: [], any: ['LinksPermissions@Edit', 'LinksPermissions@EditAll'] },
            visible: false
        },
        {
            name: '[[[Sortowanie kategorii]]]',
            route: 'intranet-link-categories-sort',
            auth: { all: [], any: ['LinksPermissions@Edit', 'LinksPermissions@EditAll'] },
            visible: false
        }
    ]);

    sitemap.find('[[[Moduły]]]', '[[[Baza dokumentów]]]').after('[[[Kategorie]]]', [
        {
            name: '[[[Dokumenty]]]',
            route: 'int-documents',
            namespace: 'Ideo.Core.Intranet.Application.Permissions.Modules',
            auth: { all: ['IntranetDocumentsPermissions@View'], any: [] },
            children: [
                {
                    name: '[[[Dodanie dokumentu]]]',
                    route: 'int-documents-add',
                    auth: { all: [], any: ['IntranetDocumentsPermissions@Edit', 'IntranetDocumentsPermission@EditAll'] },
                    visible: false
                },
                {
                    name: '[[[Edycja dokumentu]]]',
                    route: 'int-documents-edit',
                    auth: { all: [], any: ['IntranetDocumentsPermissions@Edit', 'IntranetDocumentsPermission@EditAll'] },
                    visible: false
                },
                {
                    name: '[[[Sortowanie dokumentów]]]',
                    route: 'int-documents-sort',
                    auth: { all: ['IntranetDocumentsPermissions@FileSummariesSettings'], any: [] },
                    visible: false
                }
            ]
        },
        {
            name: '[[[Kategorie]]]',
            route: 'int-documents-categories',
            namespace: 'Ideo.Core.Intranet.Application.Permissions.Modules',
            auth: { all: ['IntranetDocumentsCategoriesPermissions@View'], any: [] },
            children: [
                {
                    name: '[[[Dodanie kategorii]]]',
                    route: 'int-documents-categories-add',
                    auth: { all: ['IntranetDocumentsCategoriesPermissions@Edit'], any: [] },
                    visible: false
                },
                {
                    name: '[[[Edycja kategorii]]]',
                    route: 'int-documents-categories-edit',
                    auth: { all: ['IntranetDocumentsCategoriesPermissions@Edit'], any: [] },
                    visible: false
                }
            ]
        },
        {
            name: '[[[Ustawienia generowania streszczeń]]]',
            route: 'int-documents-file-summaries-settings',
            namespace: 'Ideo.Core.Intranet.Application.Permissions.Modules',
            auth: { all: ['IntranetDocumentsPermissions@FileSummariesSettings'], any: [] }
        }
    ]);

    sitemap.find('[[[Moduły]]]').after('[[[Baza dokumentów]]]', [
        {
            name: '[[[Forum]]]',
            icon: 'far fa-fw fa-users',
            children: [
                {
                    name: '[[[Działy]]]',
                    route: 'int-forum-sections',
                    auth: { all: ['ForumSectionsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie działu]]]',
                            route: 'int-forum-sections-add',
                            auth: { all: ['ForumSectionsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja działów]]]',
                            route: 'int-forum-sections-edit',
                            auth: { all: ['ForumSectionsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Sortowanie działów]]]',
                            route: 'int-forum-sections-sort',
                            auth: { all: ['ForumSectionsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Wątki]]]',
                    route: 'int-forum-sections-threads',
                    auth: { all: ['ForumSectionThreadsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie wątku]]]',
                            route: 'int-forum-sections-threads-add',
                            auth: { all: ['ForumSectionThreadsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja wątku]]]',
                            route: 'int-forum-sections-threads-edit',
                            auth: { all: ['ForumSectionThreadsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Wpisy]]]',
                            route: 'int-forum-sections-threads-entries',
                            auth: { all: ['ForumSectionThreadEntriesPermissions@View'], any: [] },
                            visible: false,
                            children: [
                                {
                                    name: '[[[Dodanie wpisu]]]',
                                    route: 'int-forum-sections-threads-entries-add',
                                    auth: { all: ['ForumSectionThreadEntriesPermissions@Edit'], any: [] },
                                    visible: false
                                },
                                {
                                    name: '[[[Edycja wpisu]]]',
                                    route: 'int-forum-sections-threads-entries-edit',
                                    auth: { all: ['ForumSectionThreadEntriesPermissions@Edit'], any: [] },
                                    visible: false
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]);

    sitemap.find('[[[Moduły]]]').after('[[[Galeria zdjęć]]]', [
        {
            name: '[[[Galeria zdjęć]]]',
            route: 'int-gallery',
            icon: 'far fa-fw fa-image',
            namespace: 'Ideo.Core.Intranet.Application.Permissions.Modules',
            auth: { all: ['PhotoGalleryPermissions@View'], any: [] },
            children: [
                {
                    name: '[[[Dodanie galerii]]]',
                    route: 'int-gallery-add',
                    auth: { all: [], any: ['PhotoGalleryPermissions@Edit', 'PhotoGalleryPermissions@EditAll'] },
                    visible: false
                },
                {
                    name: '[[[Edycja galerii]]]',
                    route: 'int-gallery-edit',
                    auth: { all: [], any: ['PhotoGalleryPermissions@Edit', 'PhotoGalleryPermissions@EditAll'] },
                    visible: false
                }
            ]
        },
        {
            name: '[[[Kalendarz]]]',
            icon: 'fa-regular fa-calendar-days',
            namespace: 'Ideo.Core.Elearning.Application.Permissions.Events',
            children: [
                {
                    name: '[[[Lista wydarzeń]]]',
                    route: 'elearning-events',
                    auth: { all: ['EventsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie wydarzenia]]]',
                            route: 'elearning-events-add',
                            auth: { all: [], any: ['EventsPermissions@Edit', 'EventsPermissions@EditAll'] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja wydarzenia]]]',
                            route: 'elearning-events-edit',
                            auth: { all: [], any: ['EventsPermissions@Edit', 'EventsPermissions@EditAll'] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Kategorie wydarzeń]]]',
                    route: 'elearning-events-categories',
                    auth: { all: ['EventCategoriesPermissions@Edit'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie kategorii wydarzenia]]]',
                            route: 'elearning-events-categories-add',
                            auth: { all: [], any: ['EventCategoriesPermissions@Edit', 'EventCategoriesPermissions@EditAll'] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja kategorii wydarzenia]]]',
                            route: 'elearning-events-categories-edit',
                            auth: { all: [], any: ['EventCategoriesPermissions@Edit', 'EventCategoriesPermissions@EditAll'] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Lokalizacje]]]',
                    route: 'cms-events-locations',
                    auth: { all: ['EventsLocationsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie lokalizacji]]]',
                            route: 'cms-events-locations-add',
                            auth: { all: ['EventsLocationsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja lokalizacji]]]',
                            route: 'cms-events-locations-edit',
                            auth: { all: ['EventsLocationsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                }

            ]
        },
        {
            name: '[[[Slajdery]]]',
            route: 'cms-sliders',
            icon: 'far fa-fw fa-columns-3',
            auth: { all: ['SlidersPermissions@View'], any: [] },
            children: [
                {
                    name: '[[[Dodanie slajdera]]]',
                    route: 'cms-sliders-add',
                    auth: { all: ['SlidersPermissions@Edit'], any: [] },
                    visible: false
                },
                {
                    name: '[[[Edycja slajdera]]]',
                    route: 'cms-sliders-edit',
                    auth: { all: ['SlidersPermissions@Edit'], any: [] },
                    visible: false
                }
            ]
        }
    ]);
};
